<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div v-if="useApi" class="shaixuan-item">
        <el-select v-model="filterCommunityId" filterable clearable placeholder="筛选小区（可搜索）" size="mini" style="width:220px">
          <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div v-else class="shaixuan-item project-multi">
        <el-select
          v-model="filterProjects"
          multiple
          filterable
          reserve-keyword
          collapse-tags
          clearable
          placeholder="筛选小区（可搜索）"
          size="mini"
          @change="filterList"
        >
          <el-option v-for="item in projectSelectOptions" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="filterList">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
      </div>
    </div>
    <div class="toolbar-row common-section-bg sync-toolbar">
      <div class="toolbar-left">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-refresh" @click="openSyncDrawer">同步</el-button>
        <el-button v-if="useApi && filterCommunityId" type="warning" size="mini" @click="handleOverrideAll">全量覆盖</el-button>
        <el-tag type="info" size="mini">上次同步：{{ lastSyncTime || '—' }}</el-tag>
      </div>
    </div>
    <div class="common-section-bg" style="padding: 0 16px 12px">
      <el-alert :title="useApi ? `以下为与${systemLabel}车场不一致的数据（仅标记，可单条/全量覆盖）` : '以下为与车场系统不一致的数据标记（演示数据）'" type="warning" show-icon :closable="false" />
    </div>
    <div class="common-section-bg common-section-body table-wrap">
      <el-table v-loading="listLoading" :data="displayList" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="source" label="来源" width="70" />
        <el-table-column prop="city" label="城市" width="80" />
        <el-table-column prop="project" label="项目" width="130" show-overflow-tooltip />
        <el-table-column prop="plate" label="车牌号" width="110" />
        <el-table-column prop="field" label="不一致字段" width="100" />
        <el-table-column prop="local_value" label="本地值" min-width="110" show-overflow-tooltip />
        <el-table-column prop="remote_value" label="车场值" min-width="110" show-overflow-tooltip />
        <el-table-column prop="sync_time" label="同步时间" min-width="145" show-overflow-tooltip />
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="table-action-btns">
              <el-button type="primary" size="mini" class="btn-primary-blue" @click="openDetailDrawer(scope.row)">详情</el-button>
              <el-button v-if="useApi" type="warning" size="mini" @click="overrideOne(scope.row)">覆盖</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="handlePagination"
      />
    </div>

    <!-- 数据对比详情 -->
    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="detailDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="680px"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">数据对比详情</div>
          <i class="el-icon-circle-close close-btn pointer" @click="detailDrawerVisible = false" />
        </div>
      </template>
      <div v-if="currentRow" class="custom-content vd-panel">
        <div class="vd-hero">
          <div class="vd-hero-main">
            <div class="vd-hero-title">{{ currentRow.plate || '—' }}</div>
            <div class="vd-hero-sub">{{ currentRow.project || '—' }}</div>
            <div class="vd-hero-tags">
              <el-tag size="small" type="warning" effect="plain">字段差异</el-tag>
            </div>
          </div>
          <div class="vd-hero-side">
            <div class="vd-hero-meta">
              <span class="vd-hero-label">不一致字段</span>
              <span class="vd-hero-value">{{ currentRow.field || '—' }}</span>
            </div>
            <div class="vd-hero-meta">
              <span class="vd-hero-label">同步时间</span>
              <span class="vd-hero-value">{{ currentRow.sync_time || '—' }}</span>
            </div>
          </div>
        </div>

        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>本地数据 vs {{ source }}车场数据</span>
          </div>
          <el-table :data="compareRows" size="mini" class="vd-table" stripe style="width: 100%">
            <el-table-column prop="label" label="字段" width="110" />
            <el-table-column prop="local" label="本地数据" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="{ 'text-danger': scope.row.diff }">{{ scope.row.local || '—' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="remote" :label="source + '车场数据'" min-width="140" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="{ 'text-danger': scope.row.diff }">{{ scope.row.remote || '—' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>

    <!-- 同步抽屉（海康真实接口 / 捷卫士演示） -->
    <el-drawer
      custom-class="custom-drawer"
      :visible.sync="syncDrawerVisible"
      :close-on-press-escape="false"
      :wrapper-closable="false"
      :show-close="false"
      size="600px"
      :before-close="handleDrawerClose"
    >
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ source }}数据同步</div>
          <i class="el-icon-circle-close close-btn pointer" @click="closeSyncDrawer" />
        </div>
      </template>
      <div class="custom-content sync-drawer-body vd-panel">
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>选择小区同步</span>
          </div>
          <div class="sync-action-row">
            <el-select v-model="syncCommunityId" filterable clearable placeholder="请选择小区（可搜索）" size="mini" style="flex:1">
              <el-option v-for="item in communitySelectOptions" :key="item.id || item" :label="item.name || item" :value="item.id || item" />
            </el-select>
            <el-button type="primary" size="mini" class="btn-primary-blue" :loading="syncing" :disabled="!syncCommunityId || syncing" @click="startSync">开始同步</el-button>
          </div>
        </div>
        <div class="vd-section">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>同步进度</span>
          </div>
          <div v-if="syncing || syncProgress.total > 0 || syncProgress.message" class="vd-progress-box">
            <div class="progress-text">
              <span>总数：{{ syncProgress.total }}</span>
              <span>已同步：{{ syncProgress.synced }}</span>
              <span>{{ syncProgressPercent }}%</span>
            </div>
            <el-progress :percentage="syncProgressPercent" :status="syncing ? null : 'success'" />
            <p v-if="syncProgress.message" class="progress-phase">{{ syncProgress.message }}</p>
            <p class="progress-tip">{{ syncing ? '同步进行中…' : '同步已完成' }}</p>
            <p v-if="queueWaitHint" class="progress-queue-hint">{{ queueWaitHint }}</p>
          </div>
          <el-empty v-else description="请选择小区并开始同步" :image-size="80" />
        </div>
        <div class="vd-section vd-section-last">
          <div class="vd-section-head">
            <span class="vd-section-bar" />
            <span>已同步小区列表</span>
          </div>
          <el-table :data="syncHistory" size="mini" class="vd-table" stripe style="width: 100%" max-height="280">
            <el-table-column prop="project" label="小区" min-width="100" show-overflow-tooltip />
            <el-table-column prop="total" label="总数" width="65" align="center" />
            <el-table-column prop="synced" label="已同步" width="70" align="center" />
            <el-table-column v-if="useApi" prop="abnormal_count" label="差异" width="65" align="center">
              <template slot-scope="scope">
                <span :class="{ 'text-danger': scope.row.abnormal_count > 0 }">{{ scope.row.abnormal_count || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="start_time" label="开始时间" width="145" show-overflow-tooltip />
            <el-table-column prop="end_time" label="结束时间" width="145" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.end_time || '—' }}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="75" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败' ? 'danger' : 'warning')" size="mini">{{ scope.row.status }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="阶段说明" min-width="160" show-overflow-tooltip />
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { syncDiffList, projectOptions, hikSyncLogs, jwsSyncLogs } from '../mockData'
import chechangHikVehicle from '@/api/tianzheng/chechangHikVehicle'
import chechangJwsVehicle from '@/api/tianzheng/chechangJwsVehicle'

const COMPARE_FIELD_MAP = {
  plate: '车牌号',
  owner: '业主',
  room_no: '业主房号',
  phone: '手机号',
  parking_space: '车位编号',
  expire_date: '有效期',
  jws_expire_date: '捷卫士有效期',
  hik_expire_date: '海康车辆有效期',
  vehicle_type: '车辆类型',
  person_code: '人员编码'
}

function normalizeParkingSpaceSet(value) {
  const text = String(value || '').trim()
  if (!text) return ''
  const parts = text.split(/[,，、]/).map(item => item.trim()).filter(Boolean)
  return Array.from(new Set(parts)).sort().join(',')
}

function isSyncFieldDifferent(key, local, remote) {
  const lv = String(local || '')
  const rv = String(remote || '')
  if (lv === rv) return false
  if (key === 'parking_space') {
    return normalizeParkingSpaceSet(lv) !== normalizeParkingSpaceSet(rv)
  }
  return true
}

const syncCountByProject = {
  海康: { '衡水四季花语小区': 156, '衡水君悦雅居小区': 128 },
  捷卫士: { '衡水四季花语小区': 142, '衡水君悦雅居小区': 118 }
}

export default {
  name: 'DataSyncPage',
  components: { Pagination },
  props: {
    title: { type: String, required: true },
    source: { type: String, required: true },
    useHikApi: { type: Boolean, default: false },
    useJwsApi: { type: Boolean, default: false }
  },
  data() {
    const initialLogs = this.source === '海康'
      ? JSON.parse(JSON.stringify(hikSyncLogs))
      : JSON.parse(JSON.stringify(jwsSyncLogs))
    return {
      syncing: false,
      lastSyncTime: '',
      listLoading: false,
      tableData: [],
      displayList: [],
      total: 0,
      listQuery: { page: 1, size: 10 },
      filterProjects: [],
      filterCommunityId: null,
      detailDrawerVisible: false,
      currentRow: null,
      syncDrawerVisible: false,
      syncHistory: initialLogs,
      communityOptions: [],
      syncCommunityId: null,
      syncProgress: { total: 0, synced: 0, message: '' },
      syncTimer: null,
      currentTaskId: null,
      syncStartedAt: null
    }
  },
  computed: {
    useApi() {
      return this.useHikApi || this.useJwsApi
    },
    vehicleApi() {
      return this.useJwsApi ? chechangJwsVehicle : chechangHikVehicle
    },
    systemLabel() {
      if (this.useJwsApi) return '捷卫士'
      if (this.useHikApi) return '海康'
      return this.source
    },
    projectSelectOptions() {
      return projectOptions.map(item => item.name)
    },
    communitySelectOptions() {
      if (this.useApi) return this.communityOptions
      return this.projectSelectOptions.map(name => ({ id: name, name }))
    },
    syncProgressPercent() {
      if (!this.syncProgress.total) return 0
      return Math.min(100, Math.round((this.syncProgress.synced / this.syncProgress.total) * 100))
    },
    queueWaitHint() {
      if (!this.useApi || !this.syncing || !this.syncProgress.message) return ''
      if (this.syncProgress.message.indexOf('等待队列') === -1) return ''
      if (!this.syncStartedAt) return ''
      if (Date.now() - this.syncStartedAt < 15000) return ''
      return '任务长时间未开始，请确认队列 worker 已启动：php artisan queue:work'
    },
    compareRows() {
      if (!this.currentRow) return []
      const local = this.currentRow.local_data || {}
      const remote = this.currentRow.remote_data || {}
      const keys = Object.keys(COMPARE_FIELD_MAP).filter(key => local[key] !== undefined || remote[key] !== undefined)
      return keys.map(key => ({
        label: COMPARE_FIELD_MAP[key],
        local: local[key] || '—',
        remote: remote[key] || '—',
        diff: isSyncFieldDifferent(key, local[key], remote[key])
      }))
    }
  },
  created() {
    if (this.useApi) {
      this.initVehicleApi()
    } else {
      this.tableData = syncDiffList.filter(item => item.source === this.source)
      this.refreshMockPage()
      this.syncHistory = this.syncHistory.map(item => ({
        ...item,
        total: item.sync_count || 0,
        synced: item.sync_count || 0,
        message: ''
      }))
    }
  },
  beforeDestroy() {
    this.clearSyncTimer()
  },
  methods: {
    handlePagination() {
      if (this.useApi) {
        this.fetchDiffList()
      } else {
        this.refreshMockPage()
      }
    },
    getFilteredMockRows() {
      if (!this.filterProjects.length) return this.tableData
      return this.tableData.filter(item => this.filterProjects.includes(item.project))
    },
    refreshMockPage() {
      const filtered = this.getFilteredMockRows()
      this.total = filtered.length
      const start = (this.listQuery.page - 1) * this.listQuery.size
      this.displayList = filtered.slice(start, start + this.listQuery.size)
    },
    initVehicleApi() {
      // 差异列表与同步历史立即加载，小区下拉并行拉取
      this.fetchDiffList()
      this.loadSyncHistory()
      this.vehicleApi.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
        }
      }).catch(() => {})
    },
    fetchDiffList() {
      this.listLoading = true
      const params = {
        page: this.listQuery.page,
        size: this.listQuery.size
      }
      if (this.filterCommunityId) params.community_id = this.filterCommunityId
      this.vehicleApi.diffList(params).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.tableData = res.result.list || []
          this.displayList = this.tableData
          this.total = res.result.total || 0
        }
      }).catch(() => { this.listLoading = false })
    },
    loadSyncHistory() {
      if (!this.useApi) return
      this.vehicleApi.syncHistory({ page: 1, size: 20 }).then(res => {
        if (res.code === 200) {
          this.syncHistory = (res.result.list || []).map(item => ({
            id: item.id,
            project: item.project,
            total: item.total || 0,
            synced: item.synced || item.sync_count || 0,
            abnormal_count: item.abnormal_count || 0,
            start_time: item.start_time,
            end_time: item.end_time,
            status: item.status,
            message: item.message || ''
          }))
          if (this.syncHistory.length) {
            this.lastSyncTime = this.syncHistory[0].end_time || this.syncHistory[0].start_time
          }
        }
      })
    },
    filterList() {
      this.listQuery.page = 1
      if (this.useApi) {
        this.fetchDiffList()
        return
      }
      this.refreshMockPage()
    },
    resetFilters() {
      if (this.useApi) {
        this.filterCommunityId = null
        this.listQuery.page = 1
        this.fetchDiffList()
        return
      }
      this.filterProjects = []
      this.listQuery.page = 1
      this.refreshMockPage()
    },
    openDetailDrawer(row) {
      this.currentRow = row
      this.detailDrawerVisible = true
    },
    openSyncDrawer() {
      this.syncDrawerVisible = true
      if (this.useApi) {
        this.loadSyncHistory()
      }
    },
    closeSyncDrawer() {
      if (this.syncing) {
        this.handleDrawerClose(() => { this.syncDrawerVisible = false })
        return
      }
      this.syncDrawerVisible = false
    },
    handleDrawerClose(done) {
      if (this.syncing) {
        this.$confirm('同步进行中，确定关闭？', '提示', { type: 'warning' })
          .then(() => {
            this.clearSyncTimer()
            this.syncing = false
            done()
          })
          .catch(() => {})
        return
      }
      done()
    },
    startSync() {
      if (!this.syncCommunityId) {
        this.$message.warning('请选择小区')
        return
      }
      if (this.useApi) {
        this.clearSyncTimer()
        this.syncing = true
        this.syncStartedAt = Date.now()
        this.syncProgress = { total: 0, synced: 0, message: '任务已提交…' }
        this.vehicleApi.sync({ community_id: this.syncCommunityId }).then(res => {
          if (res.code !== 200) {
            this.syncing = false
            this.$message.error(res.message || '同步失败')
            return
          }
          this.currentTaskId = res.result.task_id
          this.pollSyncProgress()
          this.syncTimer = setInterval(() => { this.pollSyncProgress() }, 1500)
        }).catch(() => { this.syncing = false })
        return
      }
      this.syncing = true
      const startBase = Date.now()
      setTimeout(() => {
        this.syncing = false
        const endBase = Date.now()
        this.lastSyncTime = this.formatNow(endBase)
        this.appendMockSyncLogs(startBase, endBase)
        this.$message.success(`${this.source}数据同步完成（演示）`)
      }, 1200)
    },
    pollSyncProgress() {
      if (!this.currentTaskId) return
      this.vehicleApi.syncProgress({ task_id: this.currentTaskId }).then(res => {
        if (res.code !== 200) return
        const data = res.result
        this.syncProgress = {
          total: data.total,
          synced: data.synced,
          message: data.message || ''
        }
        if (data.status === 'completed' || data.status === 'failed') {
          this.finishSync(data.status === 'failed', data.message)
        }
      })
    },
    finishSync(failed, message) {
      this.clearSyncTimer()
      this.syncing = false
      if (this.useApi) {
        this.loadSyncHistory()
        this.fetchDiffList()
      }
      if (failed) {
        this.$message.error(message || '同步失败，请查看同步历史')
      } else {
        this.lastSyncTime = this.formatNow(new Date())
        this.$message.success(`${this.systemLabel}数据同步完成`)
      }
    },
    clearSyncTimer() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer)
        this.syncTimer = null
      }
    },
    overrideOne(row) {
      this.$confirm(`确认用${this.systemLabel}数据覆盖本地「${row.field}」？`, '单条覆盖', { type: 'warning' }).then(() => {
        this.vehicleApi.diffOverrideOne({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('覆盖成功')
            this.fetchDiffList()
          } else {
            this.$message.error(res.message || '覆盖失败')
          }
        })
      }).catch(() => {})
    },
    handleOverrideAll() {
      if (!this.filterCommunityId) {
        this.$message.warning('请先在列表上方筛选小区')
        return
      }
      this.$confirm('确认对该小区所有待处理差异执行全量覆盖？', '全量覆盖', { type: 'warning' }).then(() => {
        this.vehicleApi.diffOverrideAll({ community_id: this.filterCommunityId }).then(res => {
          if (res.code === 200) {
            const vehicleCount = (res.result && (res.result.vehicle_count != null ? res.result.vehicle_count : res.result.count)) || 0
            const diffCount = (res.result && res.result.diff_count != null) ? res.result.diff_count : vehicleCount
            this.$message.success(`已覆盖 ${vehicleCount} 辆车（共 ${diffCount} 条差异）`)
            this.fetchDiffList()
          } else {
            this.$message.error(res.message || '覆盖失败')
          }
        })
      }).catch(() => {})
    },
    appendMockSyncLogs(startBase, endBase) {
      const counts = syncCountByProject[this.source] || {}
      const projectName = this.syncCommunityId
      const syncCount = counts[projectName] || 100
      const abnormalCount = syncDiffList.filter(
        item => item.source === this.source && item.project === projectName
      ).length
      const newLog = {
        id: Date.now(),
        project: projectName,
        total: syncCount,
        synced: syncCount,
        abnormal_count: abnormalCount,
        start_time: this.formatNow(startBase),
        end_time: this.formatNow(endBase),
        status: '已完成',
        message: '同步完成（演示）'
      }
      this.syncHistory = [newLog, ...this.syncHistory]
    },
    formatNow(dateInput) {
      const now = dateInput instanceof Date ? dateInput : new Date(dateInput)
      const pad = n => String(n).padStart(2, '0')
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';
.text-danger { color: #f56c6c; }
.progress-phase {
  margin: 8px 0 4px;
  font-size: 12px;
  color: #409eff;
  line-height: 1.5;
  word-break: break-all;
}
.progress-queue-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #e6a23c;
}
</style>

<style lang="scss">
@import '../styles/drawer-patch.scss';
</style>
